<script setup>
    import MainHeader from '@/components/HeaderComponent.vue';
    import { useRouter } from 'vue-router';
    import { inject, reactive } from 'vue';
    import { useLoginStore } from '@/stores/login/loginStore';
    import { useSigninUseridStore } from '@/stores/signin/signinUseridStore';
    import { signinUseridApplyFormInfo } from '@/models/signinModel';
    import BaseInput from '@/components/BaseInputComponent.vue';
    import Utils from '@/commonProject/helpers/utils.js';
    import { getCurrentInstance } from 'vue';
    import i18n from '@/common/i18n';
    import { useButtonDisabledStore } from '@/stores/common/disabledStore';

    // ----------------------------
    // 定数
    // ----------------------------
    const app = getCurrentInstance();

    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');

    const signinUseridApplyForm = reactive(new signinUseridApplyFormInfo());
    const router = useRouter();
    const signinUseridStore = useSigninUseridStore();
    const loginStore = useLoginStore();
    // ボタン連打ガード制御
    const disabledStore = useButtonDisabledStore();

    /**
     * ユーザID通知入力
     */
    async function sendMailUserIdNotice() {
        // バリデーションチェック
        if (isValidationError()) {
            return;
        }

        // ボタン連打ガード制御
        disabledStore.buttonTemporaryDisabled();    

        const requestBody = {
            VendorId: loginStore.vendorId,
            MailAddress: signinUseridApplyForm.emailAddress,
        };

        // ユーザID通知APIをコールする。
        const response = await signinUseridStore.sendMailUserIdNoticeAction(app.appContext.config.globalProperties.$constProperties.BASE_API_URL_P, requestBody);

        if (response.success) {
            router.push({ name: 'signinUseridComplete' });
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return;
        }
    }
    /**
     * バリデーションチェック
     */
    function isValidationError() {
        // エラーメッセージを初期化する。
        let message = '';

        // メールアドレス
        if (Utils.isNullEmpty(signinUseridApplyForm.emailAddress)) {
            message += i18n.global.t('signinUseridApply.message.message1') + '\n';
        } else {
            if (!Utils.isMatchPatternMailAddress(signinUseridApplyForm.emailAddress)) {
                message += i18n.global.t('signinUseridApply.message.message3') + '\n';
            }
        }

        // エラーメッセージが存在する場合は、以降の処理に進ませないので、バリデーションチェック判定を返却する。
        if (!Utils.isNullEmpty(message)) {
            // エラーメッセージが存在する場合は、画面に表示する。
            messageDialog('error', message);
            return true;
        }

        return false;
    }
</script>

<template>
    <section id="main" class="login extra">
        <MainHeader />
        <div id="contents" class="medium">
            <h2>{{ $t('signinUseridApply.parts.pageTitle1') }}</h2>
            <h3 style="margin-bottom: 31px">{{ $t('signinUseridApply.parts.pageInformation1') }}{{ $t('signinUseridApply.parts.pageInformation2') }}</h3>
            <section class="form">
                <dl>
                    <dt>
                        <label>{{ $t('signinUseridApply.parts.dl1') }}</label>
                    </dt>
                    <dd>
                        <BaseInput v-model:input="signinUseridApplyForm.emailAddress" type="email" />
                    </dd>
                </dl>
            </section>
            <ul class="btnArea" style="padding-top: 10px">
                <li>
                    <button type="button" class="btnPrimary" id="moveToUserIdNoticeInput" @click="sendMailUserIdNotice" :disabled="disabledStore.isDisabled">{{ $t('signinUseridApply.parts.button1') }}</button>
                </li>
            </ul>
        </div>
    </section>
</template>

<style></style>
